var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"delaccount"}},[_c('NavTop',{attrs:{"title":"更多"}}),_c('van-cell-group',{attrs:{"inset":""}},[_c('van-cell',{attrs:{"title":"注销账号","is-link":""},on:{"click":_vm.doDelAccount}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }